import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import "datatables.net-responsive-bs4";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import ImageNotFound from '../../assets/images/not-found.png';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const PageDestinations = () => {
    const [loading, setLoading] = useState(false);
    const [page_destination_id, setPageDestinationId] = useState(0);
    const [destination_title, setDestinationTitle] = useState('');
    const [destination_sub_title, setDestinationSubTitle] = useState('');
    const [destination_image, setDestinationImage] = useState('');
    const [destination_price, setDestinationPrice] = useState('');
    const [section_destinations, setSectionDestinations] = useState([]);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;
    const URLZFILES = process.env.REACT_APP_API_ZFILES;

    useEffect(() => {
        setTimeout(() => {
            $('.select2').select2({ width: "100%" });
        }, 100);
        getAll();
    }, []);

    const getAll = async () => {
        setLoading(true);
        var table = $('.main').DataTable();
        table.destroy();
        await axios.get(ENDPOINT + "get-page-destination-all").then((response) => {
            setSectionDestinations(response.data.data);
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 10,
                    responsive: true,
                    autoWidth: true,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar por destino",
                    },
                });
                setLoading(false);
            }, 100);
        })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            });
    };

    const handleNew = () => {
        clearField();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const form = new FormData();
        form.append("destination_title", destination_title);
        form.append("destination_sub_title", destination_sub_title);
        form.append("destination_image", destination_image);
        form.append("destination_price", destination_price);
        if (page_destination_id === 0) {
            await axios
                .post(ENDPOINT + "save-page-destination", form)
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        } else {
            setLoading(true);
            await axios
                .put(ENDPOINT + "update-page-destination/" + page_destination_id, {
                    destination_title: destination_title,
                    destination_sub_title: destination_sub_title,
                    destination_image: destination_image,
                    destination_price: destination_price
                })
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(true);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        }
    };

    const clearField = () => {
        setPageDestinationId(0);
        setDestinationTitle('');
        setDestinationSubTitle('');
        setDestinationPrice('');
        setDestinationImage('');
    };

    const toggleSwitch = async (val) => {
        setLoading(true);
        await axios
            .put(ENDPOINT + "get-page-destination-status/" + val)
            .then((response) => {
                getAll();
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const handleEdit = async (id) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-page-destination/" + id)
            .then((response) => {
                setLoading(false);
                setPageDestinationId(response.data.data.page_destination_id);
                setDestinationTitle(response.data.data.destination_title);
                setDestinationSubTitle(response.data.data.destination_sub_title);
                setDestinationImage(response.data.data.destination_image);
                setDestinationPrice(response.data.data.destination_price);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleDelete = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(ENDPOINT + "delete-page-destination/" + id).then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const handleFileChange = async (e) => {
        setLoading(true);
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('destination', 'zfiles/destinations/');
        await axios.post(ENDPOINT + 'upload-page-destination', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            setDestinationImage(response.data.data.pathFile);
            setLoading(false);
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 1000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image'],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ];

    return (
        <div className="page-destination">
            <ContentHeader title="Destinations" subtitle="Manage your destinations" />
            {loading && <Loader />}
            <div className="page-destination-wrapper">
                <div className="page-destination-container">    
                    <div className="page-destination-card">
                        <div className="page-destination-header">
                            <h3 className="page-destination-title">
                                <i className="bi bi-geo-alt-fill me-2"></i> 
                                Gestionar Información de Destinos
                            </h3>
                            <p className="page-destination-subtitle">
                                Complete los campos para gestionar los destinos disponibles
                            </p>
                        </div>
                        <div className="page-destination-content">
                            <div className="page-destination-actions text-end">
                                <button
                                    onClick={handleNew}
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-default"
                                    className="btn btn-primary"
                                >
                                    <i className="fas fa-plus"></i> Add Destination
                                </button>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-secondary ms-2"
                                >
                                    <i className="fas fa-sync"></i> Refresh
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-hover table-striped main">
                                    <thead>
                                        <tr>
                                            <th width="8%" className="text-center">#</th>
                                            <th className="text-left">Titulo</th>
                                            <th className="text-left">SubTitulo</th>
                                            <th className="text-left">Precio Desde</th>
                                            <th className="text-center">Imagen</th>
                                            <th width="10%" className="text-center">Estado</th>
                                            <th width="10%" className="text-center">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {section_destinations.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <kbd># {item.page_destination_id}</kbd>
                                                </td>
                                                <td>
                                                    {item.destination_title}
                                                </td>
                                                <td>
                                                    <div dangerouslySetInnerHTML={{ __html: item.destination_sub_title }} />
                                                </td>
                                                <td>
                                                    {item.destination_price}
                                                </td>
                                                <td className="text-center">
                                                    <img
                                                        className="rounded border border-secondary img-fluid"
                                                        width={200}
                                                        height={85}
                                                        rounded
                                                        src={item.destination_image ? URLZFILES + item.destination_image : ImageNotFound}
                                                        alt="banner"
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <div data-toggle="tooltip" data-placement="top" title="Estado">
                                                        <Switch
                                                            checkedIcon={false}
                                                            uncheckedIcon={false}
                                                            checked={item.status === 1 ? true : false}
                                                            onChange={() => toggleSwitch(item.page_destination_id)}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div>
                                                        <button
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#modal-default"
                                                            className="btn-sm btn btn-warning me-1"
                                                            onClick={() => handleEdit(item.page_destination_id)}
                                                        >
                                                            <i className="fa-solid fa-pen-to-square"></i>
                                                        </button>
                                                        <button
                                                            className="btn-sm btn btn-danger me-1"
                                                            onClick={() => handleDelete(item.page_destination_id, item.destination_title)}
                                                        >
                                                            <i className="fa-solid fa-trash-can"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal */}
            <div className="modal fade" id="modal-default" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="page-destination-modal-header">
                            <h4 className="page-destination-modal-title">
                                <i className="bi bi-geo-alt-fill me-2"></i>
                                {page_destination_id === 0 ? "Nuevo Destino" : "Editar Destino"}
                            </h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="page-destination-form-section">
                                    <h4 className="page-destination-section-title">Información del Destino</h4>
                                    <div className="page-destination-grid">
                                        <div className="form-group">
                                            <label className="page-destination-label">
                                                Título<span className="page-destination-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Ingrese título del destino"
                                                value={destination_title}
                                                onChange={(e) => setDestinationTitle(e.target.value)}
                                                required
                                            />
                                            <span className="page-destination-hint">Ingrese el título del destino turístico</span>
                                        </div>
                                        <div className="form-group">
                                            <label className="page-destination-label">
                                                Precio Desde<span className="page-destination-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Ingrese precio desde"
                                                value={destination_price}
                                                onChange={(e) => setDestinationPrice(e.target.value)}
                                                required
                                            />
                                            <span className="page-destination-hint">Ingrese el precio base del destino</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="page-destination-form-section">
                                    <h4 className="page-destination-section-title">Descripción</h4>
                                    <div className="form-group">
                                        <label className="page-destination-label">
                                            Subtítulo<span className="page-destination-required">*</span>
                                        </label>
                                        <ReactQuill
                                            theme="snow"
                                            value={destination_sub_title}
                                            onChange={setDestinationSubTitle}
                                            modules={modules}
                                            formats={formats}
                                            placeholder="Ingrese la descripción del destino"
                                            className="page-destination-editor"
                                        />
                                        <span className="page-destination-hint">Describa las características del destino</span>
                                    </div>
                                </div>
                                <div className="page-destination-form-section">
                                    <h4 className="page-destination-section-title">Imagen</h4>
                                    <div className="page-destination-image-upload">
                                        <div className="page-destination-preview">
                                            <img
                                                src={destination_image ? URLZFILES + destination_image : ImageNotFound}
                                                alt="Vista previa"
                                                className="page-destination-preview-img"
                                            />
                                        </div>
                                        <div className="page-destination-upload-controls">
                                            <input
                                                type="file"
                                                id="destination-image"
                                                className="page-destination-input-file"
                                                onChange={handleFileChange}
                                            />
                                            <label htmlFor="destination-image" className="page-destination-upload-label">
                                                <i className="fas fa-upload"></i>
                                                Seleccionar Imagen
                                            </label>
                                            <span className="page-destination-hint">Formato recomendado: JPG, PNG. Tamaño máximo: 2MB</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="page-destination-form-actions">
                                <button type="submit" className="page-destination-btn page-destination-btn-primary">
                                    <i className="fa-regular fa-floppy-disk"></i>
                                    {page_destination_id === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    type="button"
                                    className="page-destination-btn page-destination-btn-secondary"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PageDestinations;